__turbopack_context__.v({
  "breadcrumbCurrent": "BusinessGameHero-module-scss-module__jf02FG__breadcrumbCurrent",
  "breadcrumbLink": "BusinessGameHero-module-scss-module__jf02FG__breadcrumbLink",
  "breadcrumbSeparator": "BusinessGameHero-module-scss-module__jf02FG__breadcrumbSeparator",
  "breadcrumbs": "BusinessGameHero-module-scss-module__jf02FG__breadcrumbs",
  "container": "BusinessGameHero-module-scss-module__jf02FG__container",
  "content": "BusinessGameHero-module-scss-module__jf02FG__content",
  "ctaNote": "BusinessGameHero-module-scss-module__jf02FG__ctaNote",
  "ctaSection": "BusinessGameHero-module-scss-module__jf02FG__ctaSection",
  "hero": "BusinessGameHero-module-scss-module__jf02FG__hero",
  "highlight": "BusinessGameHero-module-scss-module__jf02FG__highlight",
  "lead": "BusinessGameHero-module-scss-module__jf02FG__lead",
  "mobileBreak": "BusinessGameHero-module-scss-module__jf02FG__mobileBreak",
  "notes": "BusinessGameHero-module-scss-module__jf02FG__notes",
  "partnerIcon": "BusinessGameHero-module-scss-module__jf02FG__partnerIcon",
  "partnerPanel": "BusinessGameHero-module-scss-module__jf02FG__partnerPanel",
  "primaryButton": "BusinessGameHero-module-scss-module__jf02FG__primaryButton",
  "stat": "BusinessGameHero-module-scss-module__jf02FG__stat",
  "statContent": "BusinessGameHero-module-scss-module__jf02FG__statContent",
  "statIcon": "BusinessGameHero-module-scss-module__jf02FG__statIcon",
  "statLabel": "BusinessGameHero-module-scss-module__jf02FG__statLabel",
  "statNumber": "BusinessGameHero-module-scss-module__jf02FG__statNumber",
  "stats": "BusinessGameHero-module-scss-module__jf02FG__stats",
  "title": "BusinessGameHero-module-scss-module__jf02FG__title",
});
